<script>
    import axios from "axios";
    export let settings;
    export let dataapi;
    export let datanik;
    let apidata = [];
    let showform = false;
    axios
      .get(settings.url + "/sipade/lay_api/" + dataapi + "/" + datanik, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        apidata = response.data;
        showform = true;
      });
      
</script>

{#if showform}
<table border="0" width="100%" class="listtable layTemplate" id="SKU-layTemplate" style="display: table;">
                    <tbody>
                
                        {#if apidata.found}
                        <tr>
                            <td class="labelform">Pilih Usaha Terdaftar</td>
                            <td class="labelform">:</td>
                            <td data-title="Pilih Usaha Terdaftar"><select name="usaha" id="usaha" class="form-select w-full m-b-10">
                                    {#each apidata.data.usaha as u}
                                    <option value="{u.id}">{u.nm} - {u.usaha}</option>
                                    {/each}
                                </select></td>
                        </tr>
                        {:else} 
                        <tr>
                            <td align="center">Tidak Menemukan Data Usaha, Silahkan Daftarkan Di Menu <b>Lumbung Ekonomi</b></td>
                        </tr>
                        {/if}
                    </tbody>
                </table>
                {/if}